import { useEffect, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  VStack,
  HStack,
  Text,
  Center,
  Stack,
  Flex,
} from "@chakra-ui/react";

// Subscriptions and functions
// import { onCreateTimeCoDailyDepartmentPunches } from '../../graphql/custom_subscriptions.js';
import { AvailableIcons } from '../Icons/AvailableIcons.jsx';
import { todaysDateYMD, spellOutDate } from '../functions/dateTime.jsx';
import { fetchISolvedPunchesByDate } from '../graphqlCompnents/TimeAttendance/fetchISolvedPunchesByDate.jsx';
// import { fetchTeamMemberCountByDivision } from '../graphqlCompnents/TimeAttendance/fetchTeamMemberCountByDivision.jsx';
import { listAllMappedDepartments } from '../graphqlCompnents/TimeAttendance/listAllMappedDepartments.jsx';
// import { generateClient } from "aws-amplify/api";

// App context
import { AppContext } from "../AppContext.jsx";

// const client = generateClient();

const PunchCard = ({
  todayLong,
  teamMemberCountAtDivision,
  totalPunchesCountAtDivision,
  teamMemberLatePunches,
  allPunchesAtDivision,
  departmentName,
  departmentCode,
}) => (
  <Box 
      w={{ 
        base: '100px',
        sm: '360px',
        md: '810px',
        lg: '1000px', 
        xl: '1200px',
        '2xl': '1600px'
      }}
      borderRadius='6px'
      p='25px'
      mt='25px'
      ml='25px'
      bg='var(--dark-module-bg)'
      overflowY={'auto'}
      minh={'100px'}
      maxH={'1000px'}
    >
    <Flex gap='25px'>
      <Box pr='25px' borderRight={'1px solid var(--dark-module-divider)'}>
        <VStack>
          <Box>
            <Center>
              <AvailableIcons color={'var(--dark-gold-primary)'} boxSize={'32px'} iconRef={'clock'} />
              <Text pl='6px' textStyle='title-clock-ins'>{todayLong} Clock Ins</Text>
            </Center>
            <Center>
              <Text pl='6px' textStyle='title-department-name'>
                {departmentName} ({departmentCode})
              </Text>
            </Center>
          </Box>
          <Box>
            <VStack>
              <Box w='60px' h='60px' borderRadius='50%' border='3px solid var(--dark-gold-primary)'>
                <Box m='20px'>
                  <Center>
                    <Text textStyle='inner-circle-1'>{teamMemberCountAtDivision}</Text>
                  </Center>
                </Box>
              </Box>
              <Box>
                <Center>
                  <Text textStyle='title-circle-1'>Total Team Members</Text>
                </Center>
              </Box>
            </VStack>
          </Box>
          
          <HStack>
            <Box pr='25px'>
              <VStack>
                <Box w='60px' h='60px' borderRadius='50%' border='3px solid var(--success-green)'>
                  <Box m='20px'>
                    <Center>
                      <Text textStyle='inner-circle-1'>{totalPunchesCountAtDivision}</Text>
                    </Center>
                  </Box>
                </Box>
                <Box>
                  <Center>
                    <Text textStyle='title-circle-1'>Total Clock Ins</Text>
                  </Center>
                </Box>
              </VStack>
            </Box>
            <Box>
              <VStack>
                <Box w='60px' h='60px' borderRadius='50%' border='3px solid var(--error-red)'>
                  <Box m='20px'>
                    <Center>
                      <Text textStyle='inner-circle-1'>{teamMemberLatePunches}</Text>
                    </Center>
                  </Box>
                </Box>
                <Box>
                  <Center>
                    <Text textStyle='title-circle-1'>Late Clock Ins</Text>
                  </Center>
                </Box>
              </VStack>
            </Box>
          </HStack>
        </VStack>
      </Box>
      <VStack>
        <Box>
          <Text textStyle="title-circle-1">Clock Ins</Text>
          {allPunchesAtDivision.length > 0 ? (
            allPunchesAtDivision.map((item, index) => {
              const timePunched = item?.timePunched || ''; 
              const [hour, minute] = timePunched ? timePunched.split(':').map(Number) : [0, 0]; 
              const punchedInLate = hour > 8 || (hour === 8 && minute > 0); // 8:00 exactly is on-time, 8:01+ is late

              return (
                <Box key={index} pt="25px">
                  <Stack direction="row">
                    <Box w="100px">
                      {item?.punchMode === 'Absence' || item?.punchMode === 'Holiday' ? (
                        <Text
                          fontWeight="600"
                          color={item.punchMode === 'Holiday' ? 'green.400' : 'orange.400'}
                        >
                          {item.punchMode}
                        </Text>
                      ) : (
                        <Text color={punchedInLate ? 'red' : 'white'}>
                          {item?.timePunched}
                        </Text>
                      )}
                    </Box>

                    <Box w="300px">
                      <Text
                        color={
                          item?.punchMode === 'Absence' || item?.punchMode === 'Holiday'
                            ? 'white'
                            : punchedInLate
                            ? 'red'
                            : 'white'
                        }
                      >
                        {item?.tmName}
                      </Text>
                    </Box>
                  </Stack>
                </Box>
              );
              // return (
              //   <Box key={index} pt="25px">
              //     <Stack direction="row">
              //       <Box w="100px">
              //         <Text color={punchedInLate ? 'red' : 'white'}>
              //           {item?.timePunched}
              //         </Text>
              //       </Box>
              //       <Box w="300px">
              //         <Text color={punchedInLate ? 'red' : 'white'}>
              //           {item?.tmName}
              //         </Text>
              //       </Box>
              //     </Stack>
              //   </Box>
              // );
            })
          ) : (
            <Text>No punch data available</Text>
          )}
        </Box>
      </VStack>
    </Flex>
  </Box>
);

// Adding prop types validation for PunchCard
PunchCard.propTypes = {
  todayLong: PropTypes.string.isRequired,
  teamMemberCountAtDivision: PropTypes.number.isRequired,
  totalPunchesCountAtDivision: PropTypes.number.isRequired,
  teamMemberLatePunches: PropTypes.number.isRequired,
  allPunchesAtDivision: PropTypes.arrayOf(
    PropTypes.shape({
      timePunched: PropTypes.string,
      tmName: PropTypes.string,
    })
  ).isRequired,
  departmentName: PropTypes.string.isRequired,
};

export const PunchTimes = () => {
  const { store } = useContext(AppContext);
  const isGlobalAdmin = store?.userData?.isGlobalAdmin || false;
  const currentDivisionId = store?.userData?.divisionId ?? '';
  const today = todaysDateYMD();
  const todayLong = spellOutDate(today, 'apple-ny');
  const [mappedDepartments, setMappedDepartments] = useState([]);
  const [departmentPunchData, setDepartmentPunchData] = useState([]);
  const [isLoadingDepartments, setIsLoadingDepartments] = useState(true);

  // 🔍 simple on/off flag for the debug panel
  // const showDebug = isGlobalAdmin; // flip to false to hide all debug UI
  const showDebug = false; // flip to false to hide all debug UI

  // 🔍 raw punches from iSolved for today (for debug)
  const [debugPunches, setDebugPunches] = useState([]);

  // useEffect(() => {
  //   const fetchDepartments = async () => {
  //     const departments = await listAllMappedDepartments();
  //     console.log('departments: ', departments);
  
  //     // Show all departments - the filter at the end will hide any with 0 punches
  //     // If you need to hide specific departments regardless of punch count, add filters here:
  //     // const filteredDepartments = departments.filter(dept => 
  //     //   dept.departmentCode !== "XX-XXXX"  // Example: hide specific department
  //     // );
      
  //     // Modify the departmentName for the department with departmentCode = "01-0012" if it exists
  //     const updatedDepartments = departments.map(dept => 
  //       dept.departmentCode === "01-0012" ? { ...dept, departmentName: "Oklahoma" } : dept
  //     );
  
  //     console.log('updatedDepartments: ', updatedDepartments);
  //     setMappedDepartments(updatedDepartments);
  //   };
  
  //   fetchDepartments();
  // }, []);

  useEffect(() => {
    const fetchDepartments = async () => {
      setIsLoadingDepartments(true);
      const departments = await listAllMappedDepartments();
      console.log('ALL mapped departments: ', departments);
      
      console.log('Department codes in mapping:', 
        departments.map(d => d.departmentCode)
      );

      // Filter to see just Oklahoma (01- prefix) departments
      const oklahomaDepartments = departments.filter(dept => 
        dept.departmentCode.startsWith('01-')
      );
      console.log('Oklahoma departments: ', oklahomaDepartments);

      // Log what we actually got
      console.log('Department codes in mapping:', 
        departments.map(d => d.departmentCode)
      );
      
      const updatedDepartments = departments.map(dept => 
        dept.departmentCode === "01-0014" ? { ...dept, departmentName: "Oklahoma" } : dept
      );
      
      console.log('Updated departments:', updatedDepartments);
      setMappedDepartments(updatedDepartments);
      setIsLoadingDepartments(false); 
    };
    
    fetchDepartments();
  }, []);

  // update daily punches
  const updateDailyPunches = useCallback(async (todayDate) => {
    console.log('updateDailyPunches called: ', todayDate);
    if (isLoadingDepartments || mappedDepartments.length === 0) {
      console.log('Waiting for departments to load...');
      return;
    }

    try {
      const todaysPunches = await fetchISolvedPunchesByDate(todayDate);
      console.log('todaysPunches: ', todaysPunches);

      // Log the different punchModes
      const uniquePunchModes = [
        ...new Set(todaysPunches.items.map(p => p.punchMode))
      ];
      console.log('Unique punchModes today:', uniquePunchModes);

      // 🔍 Save raw punches for the debug panel
      setDebugPunches(todaysPunches?.items ?? []);
      console.log("Debug punches received:", debugPunches);

      // First, let's see ALL department IDs in today's punches
      const allDepartmentIds = todaysPunches.items
        .filter(item => item?.punchMode === 'In')
        .map(item => item?.departmentId)
        .filter(Boolean);
      
      const uniqueDeptIds = [...new Set(allDepartmentIds)];
      console.log('Unique department IDs in today\'s punches:', uniqueDeptIds);
      
      // Check which ones start with 01- (Oklahoma)
      const oklahomaDeptIds = uniqueDeptIds.filter(id => id?.startsWith('01-'));
      console.log('Oklahoma department IDs in punches:', oklahomaDeptIds);

      // Group punches by departmentId
      const punchesByDepartment = todaysPunches.items.reduce((acc, item) => {
        const isStatusPunch = item?.punchMode === 'Absence' || item?.punchMode === 'Holiday';
        const isInPunch = item?.punchMode === 'In';

        if (!isInPunch && !isStatusPunch) return acc;

        const departmentId = item?.departmentId;
        const employeeName = `${item?.teamMember?.teamMember?.firstName} ${item?.teamMember?.teamMember?.lastName}`;
        const punchTime = item?.punchTime;

        if (!acc[departmentId]) {
          acc[departmentId] = { 
            punches: [],
            employees: new Set() // Track unique employees
          };
        }

        // Only add if this employee hasn't punched in yet today
        if (!acc[departmentId].employees.has(employeeName)) {
          acc[departmentId].employees.add(employeeName);
          
          const punch = {
            punchMode: item?.punchMode,
            timePunched: punchTime,
            tmName: `${item?.teamMember?.teamMember?.firstName} ${
              item?.teamMember?.teamMember?.goesBy
                ? item?.teamMember?.teamMember?.goesBy + ' '
                : ''
            }${item?.teamMember?.teamMember?.lastName}`,
            employeeNumber: item?.teamMember?.teamMember?.employeeNumber,
          };
          
          acc[departmentId].punches.push(punch);
        }

        return acc;
      }, {});

      console.log('Punches grouped by department:', punchesByDepartment);
      

      // Create department cards only for departments with punches
      const departmentsWithPunches = [];
      
      for (const [departmentId, departmentData] of Object.entries(punchesByDepartment)) {
        // Find the department name from mappedDepartments
        const departmentInfo = mappedDepartments.find(
          dept => dept.departmentCode === departmentId
        );
        
        // Since all departments ARE in your mapping table, this should always find them
        if (departmentInfo) {
          const totalPunchesCount = departmentData.punches.length;
          const latePunches = departmentData.punches.filter((item) => {
            if (item.punchMode !== 'In') return false;

            const [hour, minute] = item.timePunched?.split(':').map(Number) || [0, 0];
            return hour > 8 || (hour === 8 && minute > 0);
          }).length;
          
          departmentsWithPunches.push({
            departmentCode: departmentId,
            departmentName: departmentInfo.departmentName,
            divisionId: departmentInfo.divisionId,
            totalPunchesCount,
            latePunches,
            teamMemberCount: departmentData.punches.length,
            punches: departmentData.punches.sort((a, b) => 
              a.timePunched.localeCompare(b.timePunched)
            ),
          });
        } else {
          // This should never happen now, but just in case
          console.warn(`Unexpected: Department ${departmentId} not found in mapping`);
        }
      }
      
      // Sort departments by name
      departmentsWithPunches.sort((a, b) => 
        a.departmentName.localeCompare(b.departmentName)
      );
      
      console.log('All departments with punches:', departmentsWithPunches);
      
      // Apply role-based filtering
      let filteredData;
      
      if (isGlobalAdmin) {
        // Admins see ALL departments with punches
        filteredData = departmentsWithPunches;
        console.log('Admin view - showing all departments:', filteredData.length);
      } else {
        // Non-admins only see departments in their division
        // Get all department codes for this division
        const divisionDepartments = mappedDepartments
          .filter(dept => dept.divisionId === currentDivisionId)
          .map(dept => dept.departmentCode);
        
        console.log('User division departments:', divisionDepartments);
        
        // Filter to only show departments in user's division
        filteredData = departmentsWithPunches.filter(dept => 
          divisionDepartments.includes(dept.departmentCode)
        );
        
        console.log('Non-admin filtered data:', filteredData);
      }
      
      setDepartmentPunchData(filteredData);
      
    } catch (error) {
      console.error('Error fetching punches:', error);
    }
  }, [mappedDepartments, isLoadingDepartments, isGlobalAdmin, currentDivisionId]); // Keep all dependencies
  
  useEffect(() => {
    updateDailyPunches(today);
  }, [today, mappedDepartments, isGlobalAdmin, currentDivisionId, updateDailyPunches]);

  return (
    <>
      {/* {showDebug && (
        <Box
          mb={6}
          p={4}
          borderWidth="1px"
          borderColor="yellow.500"
          borderRadius="md"
        >
          <Text fontWeight="bold" mb={2}>
            Debug: iSolved punches for {today}
          </Text>

          <Box maxH="260px" overflowY="auto" mb={4}>
            {debugPunches.length === 0 ? (
              <Text fontSize="xs">No punches returned for today.</Text>
            ) : (
              debugPunches.map((punch, index) => (
                <HStack
                  key={punch.id || index}
                  fontSize="xs"
                  py={1}
                  borderBottomWidth="1px"
                  borderColor="gray.700"
                  alignItems="flex-start"
                >
                  <Text w="220px">
                    {punch?.teamMember?.teamMember?.firstName}{' '}
                    {punch?.teamMember?.teamMember?.goesBy
                      ? `${punch?.teamMember?.teamMember?.goesBy} `
                      : ''}
                    {punch?.teamMember?.teamMember?.lastName}
                  </Text>
                  <Text w="160px">
                    {punch?.departmentId}
                  </Text>
                  <Text w="220px">
                    {punch?.department?.departmentName ??
                      punch?.teamMember?.teamMember?.departmentName ??
                      '—'}
                  </Text>
                  <Text w="80px">
                    {punch?.punchMode}
                  </Text>
                  <Text w="120px">
                    {punch?.punchTime}
                  </Text>
                </HStack>
              ))
            )}
          </Box>

          <Text fontWeight="bold" mb={2}>
            Debug: Mapped departments ({mappedDepartments.length})
          </Text>

          <Box maxH="260px" overflowY="auto">
            {mappedDepartments.length === 0 ? (
              <Text fontSize="xs">No mapped departments loaded.</Text>
            ) : (
              mappedDepartments.map((dept, index) => (
                <HStack
                  key={dept.id || dept.departmentCode || index}
                  fontSize="xs"
                  py={1}
                  borderBottomWidth="1px"
                  borderColor="gray.700"
                >
                  <Text w="120px">
                    {dept.departmentCode}
                  </Text>
                  <Text w="240px">
                    {dept.departmentName}
                  </Text>
                  <Text w="200px">
                    {dept.divisionId}
                  </Text>
                </HStack>
              ))
            )}
          </Box>
        </Box>
      )} */}

      {isLoadingDepartments ? (
        <Center>
          <Text>Loading department data...</Text>
        </Center>
      ) : departmentPunchData.length === 0 ? (
        <Center>
          <Text>No punches recorded yet for {todayLong}</Text>
        </Center>
      ) : (
        departmentPunchData.map((department, index) => (
          <PunchCard
            key={department.departmentCode || index}
            todayLong={todayLong}
            teamMemberCountAtDivision={department.teamMemberCount}
            totalPunchesCountAtDivision={department.totalPunchesCount}
            teamMemberLatePunches={department.latePunches}
            allPunchesAtDivision={department.punches}
            departmentName={department.departmentName}
            departmentCode={department.departmentCode}
          />
        ))
      )}
      <Box h='25px' />
    </>
  );
};


PunchCard.propTypes = {
  todayLong: PropTypes.string.isRequired,
  teamMemberCountAtDivision: PropTypes.number.isRequired,
  totalPunchesCountAtDivision: PropTypes.number.isRequired,
  teamMemberLatePunches: PropTypes.number.isRequired,
  allPunchesAtDivision: PropTypes.arrayOf(
    PropTypes.shape({
      timePunched: PropTypes.string,
      tmName: PropTypes.string,
    })
  ).isRequired,
  departmentName: PropTypes.string.isRequired,
  departmentCode: PropTypes.string.isRequired,
};